import forEach from "lodash/forEach";
import isPlainObject from "lodash/isPlainObject";
import pickBy from "lodash/pickBy";

type Collection = Array<any> | object;
type FlattenedCollection<T = unknown> = Record<string, T>;

type FlattenCollectionOptions = {
  /**
   * Set to true to omit nullish values (null or undefined) from the result.
   */
  omitNullish?: boolean;
};

/**
 * Flatten a collection (object or array) into a single object with dot notation keys.
 * courtesy of https://github.com/lodash/lodash/issues/2240#issuecomment-548710378
 */
export const flattenCollection = <T>(obj = {}, { omitNullish = false }: FlattenCollectionOptions = {}): FlattenedCollection<T> => {
  const result: Record<string, T> = {};

  const flatten = (collection: Collection, prefix = "", suffix = "") => {
    forEach(collection, (value, key) => {
      const path = `${prefix}${key}${suffix}`;

      if (Array.isArray(value)) {
        flatten(value, `${path}[`, "]");
      } else if (isPlainObject(value)) {
        flatten(value, `${path}.`);
      } else {
        result[path] = value;
      }
    });
  };

  flatten(obj);

  if (omitNullish) {
    return pickBy(result, (v) => v != null);
  }
  return result;
};
